// NOTE: keep in sync with Works::Scheduling::IncentiveFormatting.format_lump_sum
// (app/services/works/scheduling/incentive_formatting.rb), which formats the same labels server-side
export function formatLumpSumAmount(dollars: number): string {
  return dollars === Math.floor(dollars)
    ? `$${Math.floor(dollars)}`
    : `$${dollars.toFixed(2)}`;
}

type TierOption = {
  label: string;
  payRate: number;
};

export function formatTierOptionLabel(
  tier: TierOption,
  displayAsLumpSum: boolean,
  shiftDuration: number
): string {
  if (displayAsLumpSum) {
    return `${tier.label} - ${formatLumpSumAmount(tier.payRate * shiftDuration)}/shift`;
  }
  return `${tier.label} - $${tier.payRate.toFixed(2)}/hr`;
}

type OverrideRateOption = {
  displayName: string;
  incentiveCents: number;
  moneyAmountCents?: number | null;
};

export function formatOverrideRateOptionLabel(
  option: OverrideRateOption,
  displayAsLumpSum: boolean,
  shiftDuration: number
): string {
  const rateInDollars = option.incentiveCents / 100;

  if (!displayAsLumpSum) {
    return `${option.displayName} - $${rateInDollars.toFixed(2)}/hr`;
  }

  const lumpInDollars =
    option.moneyAmountCents !== null && option.moneyAmountCents !== undefined
      ? option.moneyAmountCents / 100
      : rateInDollars * shiftDuration;
  return `${option.displayName} - ${formatLumpSumAmount(lumpInDollars)}/shift`;
}

export function formatBaseRateOptionLabel(
  baseRateCents: number,
  displayAsLumpSum: boolean,
  shiftDuration: number
): string {
  const rateInDollars = baseRateCents / 100;
  if (displayAsLumpSum) {
    return `Base rate - ${formatLumpSumAmount(rateInDollars * shiftDuration)}/shift`;
  }
  return `Base rate - $${rateInDollars.toFixed(2)}/hr`;
}

type CurrentRateRecord = {
  averageRate: number;
  displayAsLumpSum: boolean;
  formattedLumpSumRate: string | null;
  incentiveTierLabel: string | null;
};

export function formatCurrentRateLabel(record: CurrentRateRecord): string {
  const rateText =
    record.displayAsLumpSum && record.formattedLumpSumRate
      ? `${record.formattedLumpSumRate}/shift`
      : `$${(record.averageRate / 100).toFixed(2)}/hr`;
  return record.incentiveTierLabel
    ? `${record.incentiveTierLabel} - ${rateText}`
    : rateText;
}
